<template>
	<div class="list_row">
		<div class ="list_title">
			<h3 class ="list_title_left">{{chartMap.chartTitle}}：</h3>
			<el-link class="list_title_right" type="primary" @click="gotoChartsInfo" >查看詳情</el-link>
			<div style="clear: both;"></div>
		</div>
		<div class="item_container">
			<div ref="row1_1" class="item_box"></div>
			<div ref="row1_2" class="item_box"></div>
		</div>
	</div>
</template>

<script setup>

	import {getCurrentInstance, onBeforeUnmount, onMounted,watch, ref, toRef, provide} from 'vue'
	import * as echarts from 'echarts';


	const { proxy } = getCurrentInstance()
	const props = defineProps(['chartMap'])
	const emits = defineEmits(['gotoChartsInfo'])

	var option11
	var option12
	var myChart11
	var myChart12

	watch(() => props.chartMap.chartTotalNum, (newValue, oldValue) => {
		option11.series[0].data[0].value= newValue
		option11.series[0].data[0].name= newValue
		myChart11.setOption(option11);
	});

	watch(() => props.chartMap.chartNewNum, (newValue, oldValue) => {
		option12.series[0].data[0].value= newValue
		option12.series[0].data[0].name= newValue
		myChart12.setOption(option12);
	});

	function initData(){
		myChart11 = echarts.init(proxy.$refs.row1_1);
		myChart12 = echarts.init(proxy.$refs.row1_2);
		option11 = drawChart(props.chartMap.chartTotalNum,props.chartMap.chartTotalTilte)
		option12 = drawChart(props.chartMap.chartNewNum,props.chartMap.chartNewTilte,"#00bb66")
		myChart11.setOption(option11);
		myChart12.setOption(option12);
	}

	function gotoChartsInfo(obj){
		emits("gotoChartsInfo",proxy.chartMap)
	}


	onMounted(()=>{
		initData()
	})

	/*繪製圖*/
	function drawChart( datanum=0 , title="" ,mcolor = "#45C2E0"){
		let option = {
			tooltip: {
				trigger: 'item'
			},
			color:[mcolor],
			graphic: {
				type: 'text',
				left: 'center',
				bottom: 10,
				style: {
					text: title,
					textAlign: 'center',
					fill: mcolor, // 文字颜色
					fontSize: 14
					// ... 其他样式配置
				}
			},
			series: [
				{
					silent:true,
					name: 'Access From',
					type: 'pie',
					radius: ['60%', '70%'],
					avoidLabelOverlap: true,
					label: {
						show: true,
						position: 'center'
					},

					data: [
						{ value: datanum, name: datanum },
					]
				}
			]
		};
		return option;
	}



</script>


<style scoped>
	.item_container {
		display: flex;
		/* justify-content: center;
        align-items: center; */
	}

	.item_box {
		margin: 5px; /* 可选，用于添加两个盒子之间的间隔 */
		width: 120px;
		height: 140px;
		box-shadow: 5px 5px 10px #aaaaaa;
		border-radius: 8px;
	}
	.list_title{
		height: 55px;
	}
	.list_title_left{
		float:left;
	}
	.list_title_right{
		float:right;
		margin-top: 15px;
	}

	@media screen and (max-width: 520px) {/*小屏幕*/
		.list_row{
			margin: 10px 5px 10px 5px;
			padding: 8px 8px 8px 8px;
			border-radius: 10px;
			border: 1px solid; /* 设置边框宽度和样式 */
			border-color: #aaaaaa; /* 设置边框颜色为红色 */
		}
	}

	@media screen and (min-width: 520px) {

		.list_row{
			margin: 10px 50px 10px 50px;
			padding: 8px 8px 8px 8px;
			border-radius: 10px;
			border: 1px solid; /* 设置边框宽度和样式 */
			border-color: #aaaaaa; /* 设置边框颜色为红色 */
		}
	}
</style>